export default {
	route: {
		dashboard: 'Dashboard',
		profile: 'Profile',
		communicat: 'Communication Management',
		reportManage: 'Report Management',
		customerManage: 'Customer Management',
		telChannel: 'Telephone Channels',
		hotLine: 'Hotline Management',
		phoneRecords: 'The Phone Records',
		videoCall: 'Video Call',
		mesQuery: 'Message Query',
		pesCallRecords: 'Personal Call Records',
		callRecords: 'Call Records',
		OBRecord: 'OB Transfer Record Query',
		monitor: 'monitoring',
		phoneMonitor: 'Phone Monitoring',
		callOutMonitor: 'Call Out Monitoring',
		call: 'Call center',
		questSurver: 'Questionnaire Survey',
		callOutState: 'Call Out State',
		orgData: 'The Original Data',
		callOutActivity: 'Outbound Activities',
		callOutTask: 'Outbound Task',
		callOutTheme: 'Outbound Theme',
		performOutbound: 'Perform Outbound',
		callOutTable: 'Outbound Statements',
		IMChannel: 'IMChannel',
		servicewindow: 'Service Window',
		queueManage: 'Queue Manager',
		holidayManage: 'Holiday Management',
		imMonitor: 'IM Monitor',
		msgManage: 'Message management',
		holidayWords: 'Holiday Words Technique Configuration',
		weChatChannel: 'WeChat Channel',
		smsChannel: 'SMS Channel',
		emailChannel: 'Email Channel',
		emailAccount: 'Email Account Settings',
		mailTask: 'Mail Task Processing',
		mailTemp: 'Mail Template Settings',
		inbox: 'Inbox',
		outbox: 'Outbox',
		dustbin: 'Dustbin',
		drafts: 'Draft Box',
		favorites: 'Favorites',
		newEmail: 'The New Email',
		weiboChannel: 'Weibo Channel',
		workOrderManage: 'WorkOrder Management',
		connectPlan: 'Connect Plan',
		isc: 'Intelligent Customer Service',
		system: 'System Setting'
	},
	navbar: {
		dashboard: 'Dashboard',
		logOut: 'Log Out',
		profile: 'Profile',
	},
	login: {
		title: 'Welcome to the OCS+ service',
		titleDesc: 'After successful login, you can experience the whole product service system',
		logIn: 'Login',
		username: 'Username',
		password: 'Password',
		inputnumber: 'Account Number',
		inputpassword: 'Password',
		inpuverification: 'Verification Code'
	},
	logoImg: {
		corporate: 'Brand corporate culture slogan',
		carousel: 'Carousel map',
	},
	table: {
		dynamicTips1: 'Fixed header, sorted by header order',
		dynamicTips2: 'Not fixed header, sorted by click order',
		dragTips1: 'The default order',
		dragTips2: 'The after dragging order',
		title: 'Title',
		importance: 'Imp',
		type: 'Type',
		remark: 'Remark',
		search: 'Search',
		add: 'Add',
		export: 'Export',
		reviewer: 'reviewer',
		id: 'ID',
		date: 'Date',
		author: 'Author',
		readings: 'Readings',
		status: 'Status',
		actions: 'Actions',
		edit: 'Edit',
		publish: 'Publish',
		draft: 'Draft',
		delete: 'Delete',
		cancel: 'Cancel',
		confirm: 'Confirm'
	},

	excel: {
		export: 'Export',
		selectedExport: 'Export Selected Items',
		placeholder: 'Please enter the file name (default excel-list)'
	},
	tagsView: {
		closeOthers: 'closeOthers',
		closeAll: 'closeAll',
		close: 'close',
		refresh: 'refresh'
	}

}